import type {
  ICampaignTargetCustom,
  ICustomCampaignTargetRule,
} from "@shared/common/custom-target-condition/types";

export const sixshopUserLogin: ICustomCampaignTargetRule = {
  key: "SIXSHOP_USER_LOGIN",

  checkValidRule({ siteType }) {
    return siteType === "SIXSHOP";
  },

  getDefaultValue() {
    return {
      type: "CUSTOM",
      key: "SIXSHOP_USER_LOGIN",
      value: "EVERYONE",
    };
  },

  getShortLabel(target: ICampaignTargetCustom) {
    switch (target.value) {
      case "EVERYONE":
        return null;
      case "NO_LOGIN":
        return "비로그인 사용자";
      case "LOGIN":
        return "로그인 사용자";
      default:
        return null;
    }
  },

  checkPage(condition, { html }) {
    if (condition.key !== "SIXSHOP_USER_LOGIN") {
      return false;
    }

    if (condition.value === "EVERYONE") {
      return true;
    }

    const div = html.querySelector("div#data_div");
    if (!div) {
      return false;
    }

    const customerNo = div.getAttribute("data-customerNo");

    switch (condition.value) {
      case "NO_LOGIN":
        return customerNo === "0";
      case "LOGIN":
        return customerNo !== "0";
    }
  },
};

export default sixshopUserLogin;
